var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLateralKeyword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angles-right-small"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.490234,
    y: 0.734131,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#0869FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "angles-right-small_2",
    d: "M17.3442 12.5881L13.3442 16.5881C13.2462 16.6861 13.1182 16.7341 12.9902 16.7341C12.8622 16.7341 12.7342 16.6851 12.6362 16.5881C12.4412 16.3931 12.4412 16.0761 12.6362 15.8811L16.2822 12.2351L12.6362 8.58912C12.4412 8.39412 12.4412 8.07709 12.6362 7.88209C12.8312 7.68709 13.1483 7.68709 13.3433 7.88209L17.3433 11.8821C17.5393 12.0761 17.5392 12.3921 17.3442 12.5881ZM7.34425 7.88014C7.14925 7.68514 6.83222 7.68514 6.63722 7.88014C6.44222 8.07514 6.44222 8.39217 6.63722 8.58717L10.2832 12.2332L6.63722 15.8792C6.44222 16.0742 6.44222 16.3912 6.63722 16.5862C6.73522 16.6842 6.86322 16.7322 6.99122 16.7322C7.11922 16.7322 7.24722 16.6832 7.34522 16.5862L11.3452 12.5862C11.5402 12.3912 11.5402 12.0742 11.3452 11.8792L7.34425 7.88014Z",
    fill: "#0869FB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateralKeyword);
export default __webpack_public_path__ + "static/media/LateralKeyword.072c7304954390357d9fa8450260d955.svg";
export { ForwardRef as ReactComponent };